import { render, staticRenderFns } from "./overdue-dialog.vue?vue&type=template&id=42e636cd&scoped=true&"
import script from "./overdue-dialog.vue?vue&type=script&lang=ts&"
export * from "./overdue-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./overdue-dialog.vue?vue&type=style&index=0&id=42e636cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e636cd",
  null
  
)

export default component.exports